<template>
  <section class="judgement">
    <div v-if="pageType === 'single'" class="left title">
      <span class="isRequred" v-if="isRequired">*</span>
      <span v-if="isShowNumber == 1">{{ qNo }}</span>
    </div>
    <div class="right">
      <div class="title" v-if="question.subject_title_type == 1">
        <span class="pure-text">{{
          question.title_quote_title_num !== 0 ? optionsTitle : question.subject
        }}</span>
      </div>
      <div v-else>
        <rich-text
          :type="2"
          :content="
            question.title_quote_title_num !== 0
              ? optionsTitle
              : question.subject
          "
        />
      </div>
      <div class="answer-list">
        <div
          class="answer-item"
          v-for="(item, idx) in answerList"
          :key="idx"
          @click.stop="hanleSelect(item, idx)"
        >
          <div :class="['j-item', { checked: item.checked }]">
            <img
              v-if="item.option_key === 'positive'"
              src="@/assets/images/question/yes.png"
              alt
            />
            <img
              v-if="item.option_key === 'negative'"
              src="@/assets/images/question/no.png"
              alt
            />
            <span>{{ item.option }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/**
 * 判断题组件
 */
import RichText from '@/components/rich-text';

export default {
  name: 'Judgement',
  components: { RichText },
  props: {
    isShowNumber: {
      //是否显示序号
      type: Number,
      default: 0,
    },
    pageType: {
      type: String,
      default: 'single', // 默认单页展示
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number, // 当前题目索引
      default: 0,
    },
    titleNo: {
      type: Number, // 当前题目序号
      default: 0,
    },
    question: {
      type: Object,
      default: () => {},
    },
    answer_json: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      qNo: this.titleNo < 9 ? `0${this.titleNo}` : this.titleNo, // 问题序号

      answerList: [],
    };
  },
  mounted() {
    const list = this.question?.option || [];
    this.answerList = list.map((item) => {
      return {
        ...item,
        checked: false,
      };
    });
  },
  methods: {
    hanleSelect(item, idx) {
      for (const item of this.answerList) {
        item.checked = false;
      }
      this.answerList[idx].checked = true;
      this.$emit('change', item.option_key, this.index, this.question);
    },
  },
  computed: {
    // 标题引用前题选项
    optionsTitle() {
      const preQuestion =
        this.answer_json[this.question.title_quote_title_num - 1];
      if (this.question.title_quote_title_num !== 0 && preQuestion) {
        let optionsNames = '';
        // 判断题 量表题 打分题取同层的 option_name
        if ([3, 4, 5].includes(preQuestion.subject_type)) {
          optionsNames = preQuestion.option;
          if (preQuestion.subject_type === 3) {
            optionsNames = preQuestion.option_name || '';
          }
        } else {
          optionsNames = preQuestion.option
            .map((item) => item.option_name)
            .join(' ');
        }
        return this.question.subject.replace(/【.*?】/, optionsNames);
        // return '【】'
      } else {
        return this.question.subject.replace(/【.*?】/, '');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.judgement {
  display: flex;
  .isRequred {
    color: #ff3b30;
    font-size: 18px;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 25px;
  }
  .left {
    width: 30px;
    margin-right: 8px;
    text-align: right;
  }
  .right {
    flex: 1;
    .answer-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .answer-item {
      margin-top: 20px;
      display: flex;
      align-items: center;
      .j-item {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        height: 34px;
        color: rgba(0, 0, 0, 0.85);
        padding: 7px 10px;
        border: 1px solid rgba(0, 0, 0, 0.09);
        border-radius: 30px;
        min-width: 148px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        &.checked {
          background: rgba(255, 102, 0, 0.08);
          color: #ff6600;
          border: 1px solid #ff6600;
        }
      }
      img {
        width: 25px;
        height: 25px;
        margin-right: 8px;
      }
    }
  }
}
</style>
